module.exports = __webpack_public_path__ + "img/iconfinder_Mask_1_5947115.1d6019a0.png";